/**
 * Paper component overrides.
 * Subtle gradient surface overlay for elevation depth.
 */

import type { Theme } from '@mui/material/styles';

const paper: Theme['components'] = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
      elevation1: {
        backgroundImage: 'var(--gradient-surface)',
      },
      elevation2: {
        backgroundImage: 'var(--gradient-surface)',
      },
      elevation4: {
        backgroundImage: 'var(--gradient-surface)',
      },
      elevation8: {
        backgroundImage: 'var(--gradient-surface)',
      },
    },
  },
};

export default paper;
